import React, { } from 'react'
import img from "../../Assest/Welcome.jpg"

function Welcome() {

  return (
    <div
      className='mt-10 overflow-x-hidden mb-10'>
      {/* <h1>Welcome To Ayn Solution</h1> */}
      <h1 className='text-center text-3xl lg:text-4xl font-[poppins] px-4'>Welcome To Ayn <span className='text-[#478CCF]'>Solutions</span></h1>
      <div className='flex flex-col lg:flex-row lg:mx-4 container px-4 items-center justify-center gap-10  mt-5'>
        <div >
          <img className=' w-[500px] rounded' src={img} alt="welcome" data-robots="noindex" />
        </div>
        <div className='flex flex-col'>
          <h1 className='text-xl font-semibold lg:text-2xl '>Working Together Makes Us Stronger! </h1>
          <div className='lg:w-[600px] mt-7 flex flex-col gap-2 leading-7'>
            <h1 className='hidden'>Working Together Makes Us Stronger!</h1>
            <p>AYN Solutions is at the forefront of technological advancements, committed to delivering cutting-edge solutions that transform industries and enhance everyday life. </p>
            <p>With a focus on innovation, quality, and customer satisfaction, we aim to drive progress and set new standards in the tech world..</p>


            <p>Founded in 2023, Ayn Solutions offers comprehensive Field Operations Solutions tailored to meet your project needs. We specialize in assessing and training field personnel, ensuring they are matched with the right assignments in various industries. We also handle the promotion of job opportunities to attract top talent for field operations.</p>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Welcome